(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/poker/common/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/poker/common/assets/javascripts/prescript.js');

'use strict';

svs = svs || {};
svs.components = svs.components || {};
svs.components.poker = svs.components.poker || {};
svs.components.poker.common = svs.components.poker.common || {};

 })(window);